import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { SortOn } from '../../reducer';
import ButtonSort from '../../../../components/ProposalStatsPage/Table/ButtonSort';

interface ButtonSortContainerProps {
	field: SortOn;
	label: string;
	isDefaultDesc?: boolean;
}

const mapStateToProps = (state: StoreState, ownProps: ButtonSortContainerProps) => {
	const {
		proposalStats: {
			sort: { sortOn, ascending },
			allIds,
		},
	} = state;

	return {
		...ownProps,
		sortOn,
		isAscending: ascending,
		isDisabled: allIds.length < 2,
	};
};

export default connect(mapStateToProps)(ButtonSort);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalStatsPage/Table/ButtonSort/index.tsx